var path = 'app/scripts/modules/google/src/applicationProviderFields/gceFields.html';
var html = "<div class=\"form-group row\">\n  <div class=\"col-sm-3 sm-label-right\">GCE Settings</div>\n  <div class=\"col-sm-9 checkbox\" style=\"margin-bottom: 0; margin-top: 5px\">\n    <label>\n      <input type=\"checkbox\"\n             ng-init=\"$ctrl.initializeApplicationField('gce.associatePublicIpAddress')\"\n             ng-model=\"$ctrl.application.providerSettings.gce.associatePublicIpAddress\"/>\n      Associate Public IP Address <help-field key=\"gce.serverGroup.associatePublicIpAddress.providerField\"></help-field>\n    </label>\n  </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/scripts/modules/google/src/applicationProviderFields/gceFields.html
// module id = 1288
// module chunks = 0